import Button from '@orn/shared-web/components/Button/Button';
import { ArrowLeftIcon } from '@orn/shared-web/icons';

import MantleHorizontalLockupPrimary from '../logos/MantleHorizontalLockupPrimary';

interface ILoginHeaderProps {
  onBack?: () => void;
}

const LoginHeader = ({ onBack }: ILoginHeaderProps) => {
  return (
    <div className="relative flex w-full items-center justify-center">
      {onBack && (
        <div className="absolute left-0">
          <Button color="tertiary" size="sm" onClick={onBack} iconLeading={ArrowLeftIcon} aria-label="Go back" />
        </div>
      )}
      <MantleHorizontalLockupPrimary className="h-8 w-auto" role="img" aria-label="Mantle" />
    </div>
  );
};

LoginHeader.displayName = 'LoginHeader';

export default LoginHeader;
